module.exports = __webpack_public_path__ + "media/icons/list-bullet-32a7480d.svg";